import { breakingNews, stats } from "../data";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* soft blobs */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-accent-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute top-40 -left-28 w-[420px] h-[420px] rounded-full bg-primary-100/60 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-40 pb-10 md:pb-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-center">
          {/* copy */}
          <div className="w-full lg:w-[54%]">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              街头搭讪实拍争议 · 独立观察站
            </span>

            <h1 className="mt-6 font-heading font-extrabold text-4xl md:text-[54px] leading-[1.15] md:leading-[1.12] text-foreground-950 text-balance">
              镜头对准陌生人的那一刻，
              <br />
              边界开始<span className="text-primary-600">重新丈量</span>
            </h1>

            <p className="mt-6 text-base md:text-lg leading-8 text-foreground-700 max-w-xl">
              当「随机搭讪路人」变成流量密码，被拍的陌生人、消费的观众、逐利的创作者，都被推上同一条赛博街角。
              这里是<span className="font-semibold text-foreground-950">搭讪吃瓜</span>
              ——我们只做一件事：把搭讪实拍争议、视频伦理与路人隐私，一件件掰开讲清楚。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#hot"
                className="h-12 px-7 inline-flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-medium transition shadow-sm whitespace-nowrap"
              >
                进入热议现场
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#guide"
                className="h-12 px-7 inline-flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-800 text-[15px] font-medium transition whitespace-nowrap"
              >
                查看伦理指南
              </a>
            </div>

            {/* stats */}
            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="px-4 py-3 rounded-xl bg-background-50/80 border border-background-200">
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-heading text-2xl md:text-[26px] font-bold text-foreground-950">
                    {s.value}
                  </dd>
                  <dd className="mt-0.5 text-xs text-foreground-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* visual collage */}
          <div className="w-full lg:w-[46%]">
            <div className="relative rounded-3xl overflow-hidden shadow-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20editorial%20photography%20of%20a%20quiet%20urban%20street%20corner%20at%20golden%20hour%2C%20warm%20terracotta%20and%20cream%20tones%2C%20soft%20cinematic%20film%20grain%2C%20abstract%20documentary%20style%20with%20soft%20shadows%20and%20gentle%20depth%20of%20field%2C%20no%20visible%20people%2C%20calm%20and%20thoughtful%20mood%2C%20high%20quality%20photojournalism%20aesthetic&width=900&height=1000&seq=hero-dashan-01&orientation=portrait"
                alt="傍晚城市街角在暖光下的安静一隅，搭讪实拍争议观察配图"
                className="w-full h-[380px] md:h-[440px] lg:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>

              {/* floating card */}
              <div className="absolute left-4 bottom-4 right-4 bg-background-50/95 backdrop-blur rounded-2xl p-4 border border-background-200">
                <p className="font-heading text-[15px] md:text-base font-bold text-foreground-950 leading-snug">
                  「打招呼不等于同意被拍摄并被公开」
                </p>
                <p className="mt-1 text-xs text-foreground-500">——本周街头实拍边界热议的核心共识</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* breaking ticker */}
      <div className="relative border-t border-b border-background-200 bg-background-100/70">
        <div className="flex items-stretch">
          <div className="flex items-center gap-2 pl-4 md:pl-6 pr-4 shrink-0 bg-primary-500 text-background-50 text-sm font-semibold">
            <i className="ri-flashlight-fill"></i>
            <span className="whitespace-nowrap">滚动热点</span>
          </div>
          <div className="relative overflow-hidden flex-1 h-12">
            <div className="absolute inset-y-0 left-0 flex items-center w-max animate-ticker">
              {[0, 1].map((n) => (
                <ul key={n} className="flex items-center" aria-hidden={n === 1}>
                  {breakingNews.map((b, i) => (
                    <li key={i} className="flex items-center whitespace-nowrap px-5 text-[15px] text-foreground-700">
                      <span className="w-1 h-1 rounded-full bg-accent-500 mr-2.5"></span>
                      {b}
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}